import React, { useState } from "react";
import PageHeading from "../../CustomComponents/PageHeading";
import * as constants from "../../../constants";
import { IonButton, IonCol, IonDatetime, IonImg, IonInput, IonItem, IonLabel } from "@ionic/react";
import {
  COLLECTIONS,
  getSubCollectionDocument,
  saveDocumentData,
  uploadImageToFireStorage,
} from "../../../firebase";
import { connect } from "react-redux";
import {
  updateUserDocuments,
  userDocuments,
  updateUserVehicleDocuments,
} from "../../../Store/Actions/userInfo";
import { Camera, CameraOptions } from "@ionic-native/camera";
import firebase from "firebase";
import { CustomIonImage } from "../../CustomComponents/IonImg";

const AddInsurance: React.FC = (props: any) => {
  const [state, setState] = useState({
    documentId: "",
    documentType: "INSURANCE",
    expirationDate: "",
    insuranceCompany: "",
    policyNumber: "",
    frontDocumentImage: "",
    backDocumentImage: "",
    did: "",
  });
  React.useEffect(() => {
    if (
      !!props.location.state &&
      Object.keys(props.location.state.userInsuranceData || {}).length
    ) {
      const data = props.location.state.userInsuranceData;
      setState({
        documentId: data.documentId,
        documentType: data.documentType,
        expirationDate: data.expirationDate,
        insuranceCompany: data.additionalFields.insuranceCompany,
        policyNumber: data.additionalFields.policyNumber,
        did: data.did,
        frontDocumentImage: data.images[0],
        backDocumentImage: data.images[1],
      });
    }
    return () => {
      setState({
        documentId: "",
        documentType: "INSURANCE",
        expirationDate: "",
        insuranceCompany: "",
        policyNumber: "",
        frontDocumentImage: "",
        backDocumentImage: "",
        did: "",
      });
    };
  }, [props.location.state]);

  const handleChange = (key: any, value: any) => {
    setState({
      ...state,
      [key]: value,
    });
  };

  const handleFileUpload = async (event: any, imageType: string) => {
    const file = event.target.files[0];
    const updatedFileName = `${file.name} ${Date.now()}`;
    const response: any = await uploadImageToFireStorage(
      props.uid,
      file,
      updatedFileName,
      "documents",
    );
    setState({
      ...state,
      [imageType]: response.snapshot.metadata.fullPath,
    });
  };

  const saveDocuments = async () => {
    try {
      const vehicleData: any = await getSubCollectionDocument(
        props.uid,
        COLLECTIONS.USERS,
        COLLECTIONS.VECHICLES,
        props.location.state.vehicleId,
      );
      const {
        documentType = "INSURANCE",
        expirationDate = "",
        insuranceCompany = "",
        policyNumber = "",
        frontDocumentImage = "",
        backDocumentImage = "",
      } = state;
      if (!insuranceCompany) {
        throw new Error(constants.PLEASE_ENTER_REGISTRATION_NUMBER);
      }
      if (!policyNumber) {
        throw new Error(constants.PLEASE_ENTER_CHASSIS_NUMBER);
      }
      if (!expirationDate) {
        throw new Error(constants.PLEASE_SELECT_EXPIRATION_DATE);
      }
      if (!frontDocumentImage) {
        throw new Error(constants.PLEASE_SELECT_IMAGE_DOCUMENT);
      }

      if (!backDocumentImage) {
        throw new Error(constants.PLEASE_SELECT_BACK_IMAGE_DOCUMENT);
      }
      const payload = {
        documentId: state.policyNumber,
        documentType: state.documentType,
        expirationDate: state.expirationDate,
        additionalFields: {
          insuranceCompany: state.insuranceCompany,
          policyNumber: state.policyNumber,
        },
        images: [state.frontDocumentImage, state.backDocumentImage],
      };

      const id: any = await saveDocumentData(
        props.uid,
        payload,
        COLLECTIONS.USERS,
        COLLECTIONS.DOCUMENTS,
        state.did || "",
      );
      !!state.did
        ? await props.updateUserDocuments({
            ...payload,
            did: state.did,
          })
        : await props.userDocuments([{ ...payload, did: id.did }]);
      !!!state.did &&
        (await saveDocumentData(
          props.uid,
          {
            ...vehicleData.data,
            documentIds: [
              ...vehicleData.data.documentIds,
              `users/${props.uid}/documents/${id.did}`,
            ],
          },
          COLLECTIONS.USERS,
          COLLECTIONS.VECHICLES,
          props.location.state.vehicleId,
        ));
      !!!state.did &&
        (await props.updateUserVehicleDocuments(
          props.location.state.vehicleId,
          `users/${props.uid}/documents/${id.did}`,
        ));
      props.history.goBack();
    } catch (e: any) {
      // alert(e);
      console.error("Ins - 163", e);
    }
  };

  const options: CameraOptions = {
    destinationType: Camera.DestinationType.DATA_URL,
    sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM,
    mediaType: Camera.MediaType.ALLMEDIA,
  };

  const AccessNativeCamera = (imageType: any) => {
    Camera.getPicture(options).then(
      async (imageData) => {
        let base64Image = "data:image/jpeg;base64," + imageData;
        const res = firebase
          .storage()
          .ref()
          .child(`${props.uid}/${"documents"}/${Date.now()}`)
          .putString(base64Image, "data_url", { contentType: "image/jpeg" });
        setState({
          ...state,
          [imageType]: `${props.uid}/${"documents"}/${Date.now()}`,
        });
      },
      (err: any) => {
        console.error(err, "CamError");
      },
    );
  };

  return (
    <IonCol className="middle_panle" size-md="6">
      <div className="document-main-div">
        <PageHeading mainHeader={constants.ADD_VIRTUAL_INSURANCE} navigation={props} />
        <div className="upload-documents-div">
          <div className="documents-information-div">
            <IonLabel color="secondary" className="document-item-label">
              {constants.INSURANCE_COMPANY}
            </IonLabel>
            <IonInput
              className="input-field"
              color="tertiary"
              placeholder={constants.ENTER_INSURANCE_COMPANY_NAME}
              value={state.insuranceCompany}
              onIonChange={(event: any) => {
                handleChange("insuranceCompany", event.detail.value);
              }}
            />
          </div>
          <div className="documents-information-div">
            <IonLabel color="secondary" className="document-item-label">
              {constants.POLICY_NO}
            </IonLabel>
            <IonInput
              className="input-field"
              color="tertiary"
              placeholder={constants.ENTER_POLICY_NUMBER}
              value={state.policyNumber}
              onIonChange={(event: any) => {
                handleChange("policyNumber", event.detail.value);
              }}
            />
          </div>
          <div className="documents-information-div">
            <IonLabel color="secondary" className="document-item-label">
              {constants.EXPIRY_DATE}
            </IonLabel>
            <div className="calender">
              <IonInput
                className="calender-input calender-item"
                color="tertiary"
                placeholder={constants.DATE}
                readonly={true}
                value={new Date(state.expirationDate).getDate() || ""}
              />
              <IonInput
                className="calender-input calender-item"
                color="tertiary"
                placeholder={constants.MONTH}
                readonly={true}
                value={new Date(state.expirationDate).getMonth() || ""}
              />
              <IonInput
                className="calender-input calender-item"
                color="tertiary"
                placeholder={constants.YEAR}
                readonly={true}
                value={new Date(state.expirationDate).getFullYear() || ""}
              />
              <IonDatetime
                id="contained-button-file"
                class="date-picker"
                displayFormat="DD MM YYYY"
                placeholder="Select Date"
                // value={state.expirationDate}

                onIonChange={(event: any) => handleChange("expirationDate", event.detail.value)}
              ></IonDatetime>
              <label htmlFor="contained-button-file">
                <IonImg
                  className="calender-img"
                  src="/images/calendar1.svg"
                  alt="calendar"
                  onClick={() => document.getElementById("contained-button-file")}
                />
              </label>
            </div>
          </div>
          <div className="documents-information-div">
            <IonLabel color="secondary" className="document-item-label">
              {constants.IMAGES}
            </IonLabel>
            <div className="upload-documents">
              <div
                className="upload-rc-documents"
                onClick={() => AccessNativeCamera("frontDocumentImage")}
              >
                {!!state.frontDocumentImage ? (
                  <CustomIonImage imgpath={state.frontDocumentImage} />
                ) : (
                  <IonImg src={"/images/add.svg"} />
                )}
                {!!state.frontDocumentImage && (
                  <IonImg
                    src={"/images/close-icon.svg"}
                    className="document-remove-icon"
                    onClick={() => handleChange("frontDocumentImage", "")}
                  />
                )}
                {!!!state.frontDocumentImage && (
                  <IonLabel color="tertiary" className="upload-side">
                    {constants.UPLOAD_FRONT}
                  </IonLabel>
                )}
                <input
                  type="file"
                  className="input_type_file"
                  accept=".png , .jpg, .pdf"
                  onChange={(event: any) => {
                    handleFileUpload(event, "frontDocumentImage");
                    event.target.value = null;
                  }}
                />
              </div>
              <div
                className="upload-rc-documents"
                onClick={() => AccessNativeCamera("backDocumentImage")}
              >
                {" "}
                {!!state.backDocumentImage ? (
                  <CustomIonImage imgpath={state.backDocumentImage} />
                ) : (
                  <IonImg src={"/images/add.svg"} />
                )}
                {!!state.backDocumentImage && (
                  <IonImg
                    src={"/images/close-icon.svg"}
                    className="document-remove-icon"
                    onClick={() => handleChange("backDocumentImage", "")}
                  />
                )}
                {!!!state.frontDocumentImage && (
                  <IonLabel color="tertiary" className="upload-side">
                    {constants.UPLOAD_BACK}
                  </IonLabel>
                )}
                <input
                  type="file"
                  className="input_type_file"
                  accept=".png , .jpg, .pdf"
                  onChange={(event: any) => {
                    handleFileUpload(event, "backDocumentImage");
                    event.target.value = null;
                  }}
                />
              </div>
            </div>
            <IonLabel className="accepted-formats">{constants.FORMATS_ACCEPTED}</IonLabel>
          </div>
        </div>
        <div className="btn_parent_div document-save-button ">
          <IonButton className=" child_btn" color="primary" onClick={() => saveDocuments()}>
            <IonLabel color="customwhite">{constants.SAVE}</IonLabel>
          </IonButton>
        </div>
      </div>
    </IonCol>
  );
};

export default connect(
  ({ auth, userInfo: { userDocumentsList } }: any) => ({
    ...auth,
    userDocumentsList,
  }),
  { updateUserDocuments, userDocuments, updateUserVehicleDocuments },
)(AddInsurance);
